var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchinzaProLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.721,
    height: 21.25,
    viewBox: "0 0 179.721 21.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8877",
    "data-name": "Group 8877",
    transform: "translate(-1593 -580)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6456",
    "data-name": "Group 6456",
    transform: "translate(1593 580.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6455",
    "data-name": "Group 6455",
    transform: "translate(0 -0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6454",
    "data-name": "Group 6454",
    transform: "translate(21.709 0.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26034",
    "data-name": "Path 26034",
    d: "M152.417,131.086l-.243-.343A6.462,6.462,0,0,0,155,128.387a7.112,7.112,0,0,0,.972-2.269,3.775,3.775,0,0,0,.074-1.363,5.535,5.535,0,0,0-.4-1.3,6.65,6.65,0,0,0-2.959-3.372,9.138,9.138,0,0,0-3.2-1.054,12.725,12.725,0,0,0-1.825-.127h-4.757v20.5h2.632V131.74h2.124a13,13,0,0,0,2-.153l.149.211,5.338,7.607h3.131Zm-4.573-1.591h-2.306V121.42h2.3a7.716,7.716,0,0,1,3.466.692,4.27,4.27,0,0,1,1.994,2.052,3.031,3.031,0,0,1,.294,1.444,3.173,3.173,0,0,1-.294,1.143,4.27,4.27,0,0,1-1.994,2.052,7.721,7.721,0,0,1-3.464.692Z",
    transform: "translate(-142.912 -118.9)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26035",
    "data-name": "Path 26035",
    d: "M202.431,133.6a7.406,7.406,0,0,1-6.374,3.241,8.068,8.068,0,0,1,0-16.128,7.1,7.1,0,0,1,6.108,3.033l.149.221,2.033-1.478-.137-.205a9.275,9.275,0,0,0-8.153-4,10.49,10.49,0,1,0,0,20.979,9.856,9.856,0,0,0,8.446-4.229l.144-.211-2.068-1.435Z",
    transform: "translate(-147.456 -118.276)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26036",
    "data-name": "Path 26036",
    d: "M256.909,130.163H246.722V118.9H244.09v20.51h2.632v-6.792h10.187v6.792h2.632V118.9h-2.632Z",
    transform: "translate(-183.521 -118.651)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 2.662,
    height: 20.51,
    transform: "translate(81.067 0.25)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26037",
    "data-name": "Path 26037",
    d: "M331.022,132.325c0,.4.031.91.064,1.348-.265-.362-.582-.784-.845-1.1l-12.016-14.205H317.5v20.715h2.514V125.328c0-.391-.035-.889-.075-1.325.261.356.569.764.824,1.074L332.7,139.193l.077.092h.731V118.572h-2.486Z",
    transform: "translate(-228.726 -118.322)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26038",
    "data-name": "Path 26038",
    d: "M382.878,119.619l.04-.063V118.9H369.524v2.4H378.9l-10.926,17.4-.04.063v.655h15.041v-2.4H371.982Z",
    transform: "translate(-259.79 -118.651)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26039",
    "data-name": "Path 26039",
    d: "M431.5,139.506h2.907q-2.352-5.086-4.691-10.158-2.371-5.139-4.748-10.281c-.293.676-.623,1.357-.944,2.02-.213.442-.425.877-.625,1.311l-7.93,17.109h2.938l1.117-2.419h10.856Zm-10.738-5.1,4.19-9.071,4.2,9.071Z",
    transform: "translate(-289.065 -118.753)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26040",
    "data-name": "Path 26040",
    d: "M102.466,139.414,95.907,125.22l-4.366,9.516A7.367,7.367,0,0,0,93.625,136a6.612,6.612,0,0,0,2.167.293L94.642,133.8l1.435-3.134,2.01,4.37,1.3,2.839a9.23,9.23,0,0,1-3.033.663h-.068c-.126.007-.252.012-.38.012a9.89,9.89,0,0,1-4.79-1.264l-.638-.361L89.348,139.4h-2.94s9.223-19.8,9.517-20.476c1.589,3.436,7.884,17.079,9.455,20.476Z",
    transform: "translate(-86.408 -118.675)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_43961",
    "data-name": "Path 43961",
    d: "M8.825-3.386A3.328,3.328,0,0,1,7.8-.888,4.362,4.362,0,0,1,4.659.106H2.343v5.03H.77V-6.912H4.659a4.408,4.408,0,0,1,3.1.985A3.308,3.308,0,0,1,8.825-3.386ZM4.659-1.19a2.8,2.8,0,0,0,1.936-.57,2.093,2.093,0,0,0,.622-1.625q0-2.23-2.558-2.23H2.343V-1.19ZM17.121,5.136,14.252.21h-1.9V5.136H10.778V-6.912h3.889a5.163,5.163,0,0,1,2.308.467,3.25,3.25,0,0,1,1.409,1.262,3.518,3.518,0,0,1,.467,1.815,3.545,3.545,0,0,1-.717,2.2A3.506,3.506,0,0,1,15.981.089l3.025,5.047ZM12.351-1.052h2.316a2.628,2.628,0,0,0,1.919-.631,2.26,2.26,0,0,0,.64-1.685,2.156,2.156,0,0,0-.631-1.659,2.745,2.745,0,0,0-1.927-.588H12.351Zm14.4,6.309A6.079,6.079,0,0,1,23.69,4.47a5.757,5.757,0,0,1-2.187-2.2A6.286,6.286,0,0,1,20.7-.9a6.286,6.286,0,0,1,.8-3.172,5.757,5.757,0,0,1,2.187-2.2,6.079,6.079,0,0,1,3.059-.786,6.113,6.113,0,0,1,3.077.786A5.713,5.713,0,0,1,32-4.077,6.326,6.326,0,0,1,32.8-.9a6.326,6.326,0,0,1-.8,3.18A5.712,5.712,0,0,1,29.826,4.47,6.113,6.113,0,0,1,26.749,5.257Zm0-1.366A4.44,4.44,0,0,0,29.022,3.3a4.136,4.136,0,0,0,1.59-1.677A5.3,5.3,0,0,0,31.191-.9a5.283,5.283,0,0,0-.579-2.532A4.168,4.168,0,0,0,29.031-5.1a4.427,4.427,0,0,0-2.282-.588,4.427,4.427,0,0,0-2.282.588,4.168,4.168,0,0,0-1.582,1.668A5.283,5.283,0,0,0,22.307-.9a5.3,5.3,0,0,0,.579,2.524A4.136,4.136,0,0,0,24.476,3.3,4.44,4.44,0,0,0,26.749,3.891Z",
    transform: "translate(1739.672 595.743)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchinzaProLogoBlack);
export default __webpack_public_path__ + "static/media/archinza-pro-logo-black.9abbdd1c8b885b83a679e0e0d2deefd1.svg";
export { ForwardRef as ReactComponent };